const countriesAndRegions: any = {
    countries: {
        AF: "Afghanistan",
        AX: "Alandinseln",
        AL: "Albanien",
        DZ: "Algerien",
        AS: "Amerikanischen Samoa-Inseln",
        AD: "Andorra",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarktis",
        AG: "Antigua und Barbuda",
        AR: "Argentinien",
        AM: "Armenien",
        AW: "Aruba",
        AU: "Australien",
        AT: "Österreich",
        AZ: "Aserbaidschan",
        BS: "Bahamas",
        BH: "Bahrain",
        BD: "Bangladesch",
        BB: "Barbados",
        BY: "Belarus",
        BE: "Belgien",
        BZ: "Belize",
        BJ: "Benin",
        BM: "Bermuda",
        BT: "Bhutan",
        BO: "Bolivien",
        BA: "Bosnien und Herzegowina",
        BW: "Botswana",
        BV: "Bouvetinsel",
        BR: "Brasilien",
        IO: "Britisches Territorium des Indischen Ozeans",
        VG: "Britische Jungferninseln",
        BN: "Brunei",
        BG: "Bulgarien",
        BF: "Burkina Faso",
        BI: "Burundi",
        KH: "Kambodscha",
        CM: "Kamerun",
        CA: "Kanada",
        CV: "Kap Verde",
        BQ: "Karibische Niederlande",
        KY: "Kaimaninseln",
        CF: "Zentralafrikanische Republik",
        TD: "Tschad",
        CL: "Chile",
        CN: "China",
        CX: "Weihnachtsinsel",
        CC: "Kokos-(Keeling-)Inseln",
        CO: "Kolumbien",
        KM: "Komoren",
        CG: "Kongo (Brazzaville)",
        CD: "Kongo (Kinshasa)",
        CK: "Cookinseln",
        CR: "Costa Rica",
        HR: "Kroatien",
        CU: "Kuba",
        CW: "Curaçao",
        CY: "Zypern",
        CZ: "Tschechische Republik",
        DK: "Dänemark",
        DJ: "Dschibuti",
        DM: "Dominika",
        DO: "Dominikanische Republik",
        EC: "Ecuador",
        EG: "Ägypten",
        SV: "El Salvador",
        GQ: "Äquatorialguinea",
        ER: "Eritrea",
        EE: "Estland",
        ET: "Äthiopien",
        FK: "Falkland Inseln",
        FO: "Färöer Inseln",
        FJ: "Fidschi",
        FI: "Finnland",
        FR: "Frankreich",
        GF: "Französisch-Guayana",
        PF: "Französisch Polynesien",
        TF: "Südfranzösische Territorien",
        GA: "Gabun",
        GM: "Gambia",
        GE: "Georgien",
        DE: "Deutschland",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Griechenland",
        GL: "Grönland",
        GD: "Grenada",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GG: "Guernsey",
        GN: "Guinea",
        GW: "Guinea-Bissau",
        GY: "Guayana",
        HT: "Haiti",
        HM: "Heard-Insel und McDonald-Inseln",
        HN: "Honduras",
        HK: "Hongkong",
        HU: "Ungarn",
        IS: "Island",
        IN: "Indien",
        ID: "Indonesien",
        IR: "Iran",
        IQ: "Irak",
        IE: "Irland",
        IM: "Isle of Man",
        IL: "Israel",
        IT: "Italien",
        CI: "Elfenbeinküste",
        JM: "Jamaika",
        JP: "Japan",
        JE: "Jersey",
        JO: "Jordanien",
        KZ: "Kasachstan",
        KE: "Kenia",
        KI: "Kiribati",
        KW: "Kuwait",
        KG: "Kirgisistan",
        LA: "Laos",
        LV: "Lettland",
        LB: "Libanon",
        LS: "Lesotho",
        LR: "Liberia",
        LY: "Libyen",
        LI: "Liechtenstein",
        LT: "Litauen",
        LU: "Luxemburg",
        MO: "China MO",
        MK: "Mazedonien",
        MG: "Madagaskar",
        MW: "Malawi",
        MY: "Malaysia",
        MV: "Malediven",
        ML: "Mali",
        MT: "Malta",
        MH: "Marshallinseln",
        MQ: "Martinique",
        MR: "Mauretanien",
        MU: "Mauritius",
        YT: "Mayotte",
        MX: "Mexiko",
        FM: "Mikronesien",
        MD: "Moldawien",
        MC: "Monaco",
        MN: "Mongolei",
        ME: "Montenegro",
        MS: "Montserrat",
        MA: "Marokko",
        MZ: "Mosambik",
        MM: "Myanmar",
        NA: "Namibia",
        NR: "Nauru",
        NP: "Nepal",
        NL: "Niederlande",
        AN: "Niederländische Antillen",
        NC: "Neukaledonien",
        NZ: "Neuseeland",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigeria",
        NU: "Niue",
        NF: "Norfolkinsel",
        MP: "Nördliche Marianneninseln",
        KP: "Nord Korea",
        NO: "Norwegen",
        OM: "Oman",
        PK: "Pakistan",
        PW: "Palau",
        PS: "Palästinensisches Gebiet",
        PA: "Panama",
        PG: "Papua Neu-Guinea",
        PY: "Paraguay",
        PE: "Peru",
        PH: "Philippinen",
        PN: "Pitcairn",
        PL: "Polen",
        PT: "Portugal",
        PR: "Puerto-Rico",
        QA: "Katar",
        RE: "Wiedervereinigung",
        RO: "Rumänien",
        RU: "Russland",
        RW: "Ruanda",
        BL: "Heiliger Barthélemy",
        SH: "Heilige Helena",
        KN: "St. Kitts und Nevis",
        LC: "Heilige Lucia",
        MF: "Saint Martin (Französischer Teil)",
        PM: "St. Pierre und Miquelon",
        VC: "St. Vincent und die Grenadinen",
        WS: "Samoa",
        SM: "San Marino",
        ST: "Sao Tome und Principe",
        SA: "Saudi Arabien",
        SN: "Senegal",
        RS: "Serbien",
        SC: "Seychellen",
        SL: "Sierra Leone",
        SG: "Singapur",
        SX: "Sint Maarten",
        SK: "Slowakei",
        SI: "Slowenien",
        SB: "Salomon-Inseln",
        SO: "Somalia",
        ZA: "Südafrika",
        GS: "Südgeorgien und die Südlichen Sandwichinseln",
        KR: "Südkorea",
        SS: "Südsudan",
        ES: "Spanien",
        LK: "Sri Lanka",
        SD: "Sudan",
        SR: "Suriname",
        SJ: "Spitzbergen und Jan Mayen",
        SZ: "Swasiland",
        SE: "Schweden",
        CH: "Schweiz",
        SY: "Syrien",
        TW: "Taiwan",
        TJ: "Tadschikistan",
        TZ: "Tansania",
        TH: "Thailand",
        TL: "Timor-Leste",
        TG: "Togo",
        TK: "Tokelau",
        TO: "Tonga",
        TT: "Trinidad und Tobago",
        TN: "Tunesien",
        TR: "Türkei",
        TM: "Turkmenistan",
        TC: "Turks- und Caicosinseln",
        TV: "Tuvalu",
        VI: "Amerikanische Jungferninseln",
        UG: "Uganda",
        UA: "Ukraine",
        AE: "Vereinigte Arabische Emirate",
        GB: "Großbritannien",
        US: "Vereinigte Staaten von Amerika",
        UM: "Kleinere abgelegene Inseln der Vereinigten Staaten",
        UY: "Uruguay",
        UZ: "Usbekistan",
        VU: "Vanuatu",
        VA: "Vatikan",
        VE: "Venezuela",
        VN: "Vietnam",
        WF: "Wallis und Futuna",
        EH: "Westsahara",
        YE: "Jemen",
        ZM: "Sambia",
        ZW: "Simbabwe",
    },
    regions: {
        "123": "Andalusien",
        "124": "Aragon",
        "125": "Asturien",
        "126": "Balearen",
        "127": "Baskenland",
        "128": "Kanarische Inseln",
        "129": "Kantabrien",
        "130": "Kastilien und León",
        "131": "Kastilien–La Mancha",
        "132": "Katalonien",
        "133": "Ceuta",
        "134": "Extremadura",
        "135": "Galicien",
        "136": "La Rioja (Spanien)",
        "137": "Madrid",
        "138": "Melilla",
        "139": "Murcia",
        "140": "Navarra",
        "141": "Valencianische Gemeinschaft",
        "142": "Attika",
        "143": "Zentralgriechenland",
        "144": "Zentralmakedonien",
        "145": "Kreta",
        "146": "Ostmakedonien und Thrakie",
        "147": "Epirus",
        "148": "Ionische Inseln",
        "149": "Nordägäis",
        "150": "Peloponnes",
        "151": "Südliche Ägäis",
        "152": "Thessalien",
        "153": "Westgriechenland",
        "154": "Westmazedonien",
        "155": "Aveiro",
        "156": "Beja",
        "157": "Braga",
        "158": "Braganca",
        "159": "Castello Branco",
        "160": "Coimbra",
        "161": "Évora",
        "162": "Faro",
        "163": "Guarda",
        "164": "Leiria",
        "165": "Lissabon",
        "166": "Portalegre",
        "167": "Porto",
        "168": "SantarÃÂ©m",
        "169": "Santarém",
        "170": "Viana do Castelo",
        "171": "Villa Real",
        "172": "Viseu",
        "173": "Norden",
        "174": "Süden",
        "175": "Zentrum",
        "176": "Andamanen und Nicobar Inseln",
        "177": "Andhra Pradesh",
        "178": "Arunachal Pradesh",
        "179": "Assam",
        "180": "Bihar",
        "181": "Chandigarh",
        "182": "Chhattisgarh",
        "183": "Dadra und Nagar Haveli",
        "184": "Daman und Diu",
        "185": "Goa",
        "186": "Gujarat",
        "187": "Haryanav",
        "188": "Himachal Pradesh",
        "189": "Jammu und Kashmir",
        "190": "Jharkhand",
        "191": "Karnataka",
        "192": "Kerala",
        "193": "Lakshadweep",
        "194": "Madhya Pradesh",
        "195": "Maharashtra",
        "196": "Manipur",
        "197": "Meghalaya",
        "198": "Mizoram",
        "199": "Nagaland",
        "200": "Nationales Hauptstadtterritorium Delhi",
        "201": "Odisha",
        "202": "Puducherry",
        "203": "Punjab",
        "204": "Rajasthan",
        "205": "Sikkim",
        "206": "Tamil Nadu",
        "207": "Telangana",
        "208": "Tripura",
        "209": "Uttar Pradesh",
        "210": "Uttarakhand",
        "211": "West Bengal",
        "212": "New South Wales",
        "213": "Queensland",
        "214": "Süd Australien",
        "215": "Tasmanien",
        "216": "Victoria",
        "217": "West Australien",
        "218": "Nordterritorium",
        "219": "Pazifische Insel",
        "220": "Papua Neu-Guinea",
        "221": "Adana",
        "222": "Adıyaman",
        "223": "Afyonkarahisar",
        "224": "Ağri",
        "225": "Aksaray",
        "226": "Amasja",
        "227": "Ankara",
        "228": "Antalya",
        "229": "Ardahan",
        "230": "Artvin",
        "231": "Aydın",
        "232": "Balıkesir",
        "233": "Bartın",
        "234": "Batman",
        "235": "Bayburt",
        "236": "Bilecik",
        "237": "Bingöl",
        "238": "Bitlis",
        "239": "Bolu",
        "240": "Burdur",
        "241": "Bursa",
        "242": "Kanakkale",
        "243": "Cankiri",
        "244": "Corum",
        "245": "Denizli",
        "246": "Diyarbakir",
        "247": "Duzce",
        "248": "Edirne",
        "249": "Elazig",
        "250": "Erzincan",
        "251": "Erzurum",
        "252": "Eskisehir",
        "253": "Gaziantep",
        "254": "Giresun",
        "255": "Gumushane",
        "256": "Hakkari",
        "257": "Hatay",
        "258": "Iğdır",
        "259": "Isparta",
        "260": "Istanbul",
        "261": "Kahramanmaras",
        "262": "Karabuk",
        "264": "Karaman",
        "265": "Kars",
        "266": "Kastamonu",
        "267": "Kayseri",
        "268": "Kilis",
        "269": "Kırıkkale",
        "270": "Kirklareli",
        "271": "Kirsehir",
        "272": "Kocaeli",
        "273": "Konya",
        "274": "Kütahya",
        "275": "Malatya",
        "276": "Manisa",
        "277": "Mardin",
        "278": "Myrte",
        "279": "Mugla",
        "280": "Mus",
        "281": "Nevsehir",
        "282": "Nigde",
        "283": "Ordu",
        "284": "Osmaniye",
        "285": "Rise",
        "286": "Sakarya",
        "287": "Samsun",
        "288": "Sanliurfa",
        "289": "Siirt",
        "290": "Sinop",
        "291": "Sirnak",
        "292": "Sivas",
        "293": "Tekirdag",
        "294": "Tokat",
        "295": "Trabzon",
        "296": "Tunceli",
        "297": "Usak",
        "298": "Van",
        "299": "Yalova",
        "300": "Yozgat",
        "301": "Baja California",
        "302": "Baja California Sur",
        "303": "Chihuahua",
        "304": "Durango",
        "305": "Sinaloa",
        "306": "Sonora",
        "307": "Coahuila",
        "308": "Nuevo",
        "309": "Leon",
        "310": "Tamaulipas",
        "311": "Aguascalientes",
        "312": "Guanajuato",
        "313": "Queretaro",
        "314": "San Luis Potosi",
        "315": "Zacatecas",
        "316": "Bundesland",
        "317": "Mexiko",
        "318": "Morelos",
        "319": "Colima",
        "320": "Jalisco",
        "321": "Michoacan",
        "322": "Nayarit",
        "323": "Hidalgo",
        "324": "Puebla",
        "325": "Tlaxcala",
        "326": "Veracruz",
        "327": "Campeche",
        "328": "Quintana Roo",
        "329": "Tabasco",
        "330": "Yucatan",
        "331": "Chiapas",
        "332": "Guerrero",
        "333": "Oaxaca",
        "334": "Britisch-Kolumbien",
        "335": "Alberta",
        "336": "Saskatchewan",
        "337": "Manitoba",
        "338": "Ontario",
        "339": "Quebec",
        "340": "New  Brunswick",
        "341": "Prinz Edward Insel",
        "342": "Neuschottland",
        "343": "Neufundland und Labrador",
        "344": "Yukon",
        "345": "Nordwest",
        "346": "Territorien",
        "347": "Nunavut",
        "348": "Alabama",
        "349": "Alaska",
        "350": "Arizona",
        "351": "Arkansas",
        "352": "Kalifornien",
        "353": "Kolorado",
        "354": "Connecticut",
        "355": "Delaware",
        "356": "Florida",
        "357": "Georgien",
        "358": "Hawaii",
        "359": "Idaho",
        "360": "Illinois",
        "361": "Indiana",
        "362": "Iowa",
        "363": "Kansas",
        "364": "Kentucky",
        "365": "Louisiana",
        "366": "Maine",
        "367": "Maryland",
        "368": "Massachusetts",
        "369": "Michigan",
        "370": "Minnesota",
        "371": "Mississippi",
        "372": "Missouri",
        "373": "Montana",
        "374": "Nebraska",
        "375": "Nevada",
        "376": "New Hampshire",
        "377": "New Jersey",
        "378": "New Mexico",
        "379": "New York",
        "380": "Nordkarolina",
        "381": "Norden",
        "382": "Dakota",
        "383": "Ohio",
        "384": "Oklahoma",
        "385": "Oregon",
        "386": "Pennsylvania",
        "387": "Rhode Island",
        "388": "Südkarolina",
        "389": "Süddakota",
        "390": "Tennessee",
        "391": "Texas",
        "392": "Utah",
        "393": "Vermont",
        "394": "Virginia",
        "395": "Washington",
        "396": "West Virginia",
        "397": "Wisconsin",
        "398": "Wyoming",
        "399": "Abruzzen",
        "400": "Aostatal",
        "401": "Apulien",
        "402": "Basilika",
        "403": "Kalabrien",
        "404": "Kampanien",
        "405": "Emilia-Romagna",
        "406": "Friaul-Julisch Venetien",
        "407": "Lazio",
        "408": "Ligurien",
        "409": "Lombardei",
        "410": "Marche",
        "411": "Molise",
        "412": "Piemont",
        "413": "Sardinien",
        "414": "Sizilien",
        "415": "Trentino-Südtirol/Südtirol",
        "416": "Toskana",
        "417": "Umbrien",
        "418": "Venetien",
        "419": "Acre",
        "420": "Alagoas",
        "421": "Amapa",
        "422": "Amazonas",
        "423": "Bahia",
        "424": "Ceara",
        "425": "Distrito Federal",
        "426": "Espirito Santo",
        "427": "Goias",
        "428": "Maranhao",
        "429": "Mato Grosso",
        "430": "Mato Grosso do Sul",
        "431": "Minas Gerais",
        "432": "Para",
        "433": "Paraiba",
        "434": "Parana",
        "435": "Pernambuk",
        "436": "Piaui",
        "437": "Rio de Janeiro",
        "438": "Rio Grande do Norte",
        "439": "Rio Grande do Sul",
        "440": "Rondonia",
        "441": "Roraima",
        "442": "Santa Catarina",
        "443": "Sao Paulo",
        "444": "Sergipe",
        "445": "Tocantins",
        "446": "Elsass: Lothringen und Champagne-Ardenne",
        "447": "Aquitanien: Limousin und Poitou-Charentes",
        "448": "Auvergne-Rhone-Alpes",
        "449": "Bourgogne-Franche-Comte",
        "450": "Bretagne",
        "451": "Zentrum-Loiretal",
        "452": "Korsika",
        "453": "Ile-de-France",
        "454": "Midi-Pyrenees und Languedoc-Roussillon",
        "455": "Nord-Pas-de-Calais-Picardie",
        "456": "Normandie",
        "457": "Länder der Loire",
        "458": "Provence-Alpes-Cote d`Azur",
        Territory: "Territory",
        Anhui: "Anhui",
        Beijing: "Beijing",
        "Chinese Taipei": "Chinese Taipei",
        "Chong Qing": "Chong Qing",
        Fujian: "Fujian",
        Gansu: "Gansu",
        Guangdong: "Guangdong",
        Guangxi: "Guangxi",
        Guizhou: "Guizhou",
        Hainan: "Hainan",
        Hebei: "Hebei",
        Heilongjiang: "Heilongjiang",
        Henan: "Henan",
        "Hong Kong": "Hong Kong",
        Hubei: "Hubei",
        Hunan: "Hunan",
        Jiangsu: "Jiangsu",
        Jiangxi: "Jiangxi",
        Jilin: "Jilin",
        Liaoning: "Liaoning",
        Macao: "Macao",
        "Nei Mongol": "Nei Mongol",
        Ningxia: "Ningxia",
        Qinghai: "Qinghai",
        Shaanxi: "Shaanxi",
        Shandong: "Shandong",
        Shanghai: "Shanghai",
        Shanxi: "Shanxi",
        Sichuan: "Sichuan",
        Tianjin: "Tianjin",
        Xinjiang: "Xinjiang",
        Xizang: "Xizang",
        Yunnan: "Yunnan",
        Zhejiang: "Zhejiang",
    },
};

export default countriesAndRegions;
